import React from 'react';
import type {ScenarioCaseExecutionStatus} from '@api';

const statusDisplayMap: Record<
    ScenarioCaseExecutionStatus,
    {text: string; className: string}
> = {
    passed: {
        text: 'Passed',
        className: 'bg-success-subtle text-success-emphasis',
    },
    failed: {
        text: 'Failed',
        className: 'bg-danger-subtle text-danger-emphasis',
    },
    pending: {
        text: 'Pending',
        className: 'bg-warning-subtle text-warning-emphasis',
    },
    running: {
        text: 'Running',
        className: 'bg-info-subtle text-info-emphasis',
    },
    error: {
        text: 'Error',
        className: 'bg-danger-subtle text-danger-emphasis',
    },
};

type Props = {
    status: ScenarioCaseExecutionStatus;
    className?: string;
};

export const ScenarioCaseStatusBadge: React.FC<Props> = ({
    status,
    className = '',
}) => {
    const display = statusDisplayMap[status] || {
        text: 'Unknown',
        className: 'bg-body-secondary text-body',
    };

    return (
        <span className={`badge rounded-1 ${display.className} ${className}`}>
            {display.text}
        </span>
    );
};
